import HeaderOne from '../../common/header/HeaderOne';
import FooterOne from '../../common/footer/FooterOne';
import {Banner, Counter, Team}  from '../layouts/home01/index';
// import CourseGridPopular from '../layouts/home02/CourseGridPopular'
// import FloatingChat from '../layouts/floatButton/FloatButton';
import Why from '../layouts/home01/Why';
import Partnership from '../layouts/home01/Partnership';
import KommoLiveChat from '../layouts/home01/KommoLiveChat';
import CoursePreview from '../layouts/home01/CoursePreview';
import StudentTestimonial from '../layouts/home01/StudentTestimonial';

const HomeOne = () => {
    return (
        <div className="home-page">       
            <HeaderOne id='top-header'/>
            <KommoLiveChat />
            <Banner />
            <Counter />
            <Why />
            <Partnership />
            <CoursePreview />
            <StudentTestimonial />
            {/* <CourseGridPopular /> */}
            <Team />
            <FooterOne/>  
        </div>
    )
}

export default HomeOne;